/* eslint-disable prettier/prettier */
import sirepAPI from "@/api/sirepApi";
import sirepApiFiles from "@/api/sirepApiFiles"
export const loadNameCourts = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/courts_list") 
        return {data} 
    } catch (error) {
        return {message:error}
    }    
};
export const loadTypeCourts = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/types_of_courts")    
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const loadTypeCodes = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/types_of_code")    
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const loadTypeOrders = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/types_of_order")    
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const loadPrisionNames = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/prision_names")    
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const loadCrimes = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/crimes")    
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const loadDocumentTypes = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/document_types")    
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const checkData = async ({ commit }, { data, type }) => {
  try {
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const ci_usuario = userData.nro_documento;

    let payload = {};

    if (type === "complete" && data.token) {
      payload = {
        token: data.token,
        ci_usuario,
        type,
      };
    } else {
      const { numero_documento, complemento } = data;

      payload = {
        numero_documento,
        complemento,
        ci_usuario,
        type,
      };
    }

    const response = await sirepAPI.post("/segip/consult", payload);

    const resp = response.data;

    if (!resp.found) {
      commit("segipResponse", {
        data: resp.message || "No existe información",
      });

      return resp;
    }

    commit("segipResponse", {
      data: resp.data,
    });

    return resp;

  } catch (error) {
    console.error(
      "Error Vue SEGIP:",
      error.response ? error.response.data : error.message
    );

    return {
      found: false,
      message:
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
        ? error.response.data.message
        : "Error en la consulta",
      data: null,
    };
  }
};

export const loadPenitenciariesCenters = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/nombre_centros")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
export const loadDepartaments = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/departaments_names")  
        return {data} 
    } catch (error) {
        return {message:error}
    }
    
}
export const loadProvinces= async({ commit }, id)=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/provinces_names/" + id)  
        commit("listProvinces",{data})
        return {data} 
    } catch (error) {
        return {message:error}
    }
    
}

export const loadMunicipalities = async({ commit }, data)=>{
    const {dep, prov} = data
    try {
        const {data} = await sirepAPI.get("/filiacion/municipalities_names/" + dep + "/" + prov)
        commit("listMunicipalities",{data})
        return {data} 
    } catch (error) {
        return {message:error}
    }   
}
export const loadCivilStatus = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/civil_status")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
export const loadEthnicIdentification = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/ethnic_identification")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
export const loadLanguages = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/languages")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
export const loadSexualOrientation = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/sexual_orientation")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
export const loadReligion = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/religion")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
export const loadProfession = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/profession")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
export const loadJob = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/job")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
export const loadDegreeInstruction = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/degree_instruction")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
export const loadRelationship = async()=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/relationship")     
        return {data} 
    } catch (error) {
        return {message:error}
    } 
}
// eslint-disable-next-line
export const sendRegistrationForm = async({ commit }, form)=>{
    try {
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepAPI.post("/filiacion/filiacion_ppl/"+ userLogged, form)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
    
}
// eslint-disable-next-line
export const printKardex = async({commit}, id) => {
    try {
         const response =  await sirepAPI.get("/filiacion/kardex_report/"+id,{
            responseType:'blob'
         })
        return response.data
    } catch (error) {
        return {message:error}
    }
}
export const loadPrivateLibertyList = async({commit}, data)=>{
    const{departamento_supervisar, id_recinto}=data
    const departamento = departamento_supervisar.value === null ||departamento_supervisar.value === 'null' ? departamento_supervisar.value = 0 : departamento_supervisar.value;
    try {
        const {data} = await sirepAPI.get("/filiacion/listDeprivedLibertyByPrisons/"+ departamento+"/"+id_recinto.value)
        //commit("listPrivatedLibertyPersons",{data})
        return {data} 
    } catch (error) {
        return {message:error}
    }       
}
// eslint-disable-next-line
export const uploadFile = async({commit}, id) =>{
    const formData = new FormData();
        formData.append('uploaded_file', id[0]);
    try {
        var ext = id[0].name.split('.').pop();
                if(ext!=='pdf' && ext!=='PDF'){
                    alert("error")
                    return false
                  }
        //let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepApiFiles.post("/filiacion/uploadFile/"+ id[1], formData)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const uploadfingerFile = async({commit}, id) =>{
    const formData = new FormData();
        formData.append('uploaded_file', id[0]);
    try {
        var ext = id[0].name.split('.').pop();
                if( ext!=='jpeg' && ext!=='png' && ext!=='jpg'){
                    alert("error")
                    return false
                  }
        const {data} = await sirepApiFiles.post("/filiacion/uploadFingerPrints/"+ id[1], formData)
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
// eslint-disable-next-line
export const printResolution = async ({commit}, id) => {
    try {
        const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/filiacion/view_file/"+id)
        return resp
        // const response =  await sirepAPI.get("/filiacion/view_file/"+id,{
        //     responseType:'blob'
        //  })
        // return response.data
    } catch (error) {
        return {message:error}
    }
}
export const viewFingerPrints = ({commit}, id) => {
    try {
        const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/filiacion/view_finger_prints/"+id)
        return resp
    } catch (error) {
        return {message:error}
    }
}
// eslint-disable-next-line
export const deleteFile = async({commit}, id) =>{
    try {
        const {data} = await sirepAPI.patch("/filiacion/delete_file/"+ id)
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const deleteFingerPrint = async({commit}, id) =>{
    try {
        const {data} = await sirepAPI.patch("/filiacion/delete_finger_print/"+ id)
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
// export const loadCrimes = async()=>{
//     try {
//         const {data} = await sirepAPI.get("/filiacion/delitos")  
//         return {data} 
//     } catch (error) {
//         return {message:error}
//     }
    
// }
// eslint-disable-next-line
export const loadDataById = async({commit},data)=>{
    if(!data){
        return
    }
    const{id_persona, id_casoppl}=data
    try {
        const {data} = await sirepAPI.get("/filiacion/datos_por_id/" + id_persona + "/" + id_casoppl) 
        return {data} 
    } catch (error) {
        return {message:error}
    }
    
}
export const loadCountPersonsCenter = async({commit})=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/personas_centro")
        commit("countPersonsCenter",{data})
        return {data} 
    } catch (error) {
        return {message:error}
    }   
}
export const loadCountGenrePersonsCenter = async({commit})=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/personas_genero")
        commit("countGenrePersonsCenter",{data})
        return {data} 
    } catch (error) {
        return {message:error}
    }   
}
export const loadCountPersonsLegalStatus = async({commit})=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/personas_situacion_juridica")
        commit("countPersonsLegalStatus",{data})
        return {data} 
    } catch (error) {
        return {message:error}
    }   
}
export const loadCountPersonsByDepartment = async({commit})=>{
    try {
        const {data} = await sirepAPI.get("/filiacion/personas_por_departamento")
        commit("countPersonsByDepartment",{data})
        return {data} 
    } catch (error) {
        return {message:error}
    }   
}
export const passData = async({ commit }, info)=>{
    const {id_persona, id_orden_judicial}= info
    try {
         const {data} = await sirepAPI.get("/filiacion/datos_por_id/" + id_persona + "/" + id_orden_judicial)
         localStorage.setItem("edit", JSON.stringify(data));
         commit("dataEdit",{data})
         return ({data})
    } catch (error) {
        return {message:error}
    }   
}
export const fotosPorId = async({ commit }, info)=>{
    const {id_persona}= info
    try {
         const {data} = await sirepAPI.get("/filiacion/fotografias_por_id/" + id_persona)
         return ({data})
    } catch (error) {
        return {message:error}
    }   
}
export const sendEdition = async({ commit }, info)=>{
     const {dato, params}= info
    let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
    try {
         const {data} = await sirepAPI.patch("/filiacion/edit/" + userLogged + "/" + params.id_person + "/" + params.id_order, {dato})
         if(data.ok){localStorage.removeItem('edit')}
          return ({data})
    } catch (error) {
        return {message:error}
    }   
}
export const resetStatusEdit = async({ commit })=>{
    try {
        //const {data} = await sirepAPI.get("/filiacion/nombre_municipios/" + dep + "/" + prov)
        commit("resetStatusEdit")
        return 'ok'
    } catch (error) {
        return {message:error}
    }   
}
export const chartData = async({ commit }, info)=>{
    try {
       const {data} = await sirepAPI.post("/filiacion/chart_data/" , info)
       if(data[0].primer){
           commit("chartDataTwoParams", {data})
       }else{
       commit("chartData",{data})
       }
        return {data} 
    } catch (error) {
        return {message:error}
    }   
}
export const personalData = async({ commit }, data)=>{
    try {
        commit("personalData",{data});        
    } catch (error) {
        return {message:error}
    }   
}
export const checkDataAlreadyExist = async({ commit }, array)=>{
    try {
        let {numero_documento, nombres, primerApellido, segundoApellido} = array.datos.value.personalData;
        numero_documento==='' ||  numero_documento=== null?numero_documento=0:numero_documento;
        primerApellido==='' || primerApellido==='--' || primerApellido===null?primerApellido=0:primerApellido.toUpperCase();
        try {
            const {data} = await sirepAPI.get("/filiacion/verificar_existencia/" + numero_documento + "/" +nombres + "/" + primerApellido + "/" + segundoApellido.toUpperCase())
              if(data.exist){
                commit("dataChecked",{data})
                return ({data})
            }else{
                commit("dataChecked",{data:null})
               return ({data:null})
            }
            } catch (error) {
                console.log(error);
                   return {message:error}
               }
    } catch (error) {
        return {message:error}
    }   
}
export const posibleOrder = async({ commit }, data)=>{
    try {
        commit("posibleOrder",{data});        
    } catch (error) {
        return {message:error}
    }   
}
export const registerReentry = async({commit},id) =>{
    try {
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepAPI.post("/filiacion/baja_ppl_reingreso/"+ userLogged + "/" + id)
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const uploadFingerPrints = async({commit},value) =>{
    try {
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const{fingerprints, id_persona }=value;
        const {data} = await sirepAPI.post("/filiacion/upload_fingerprints/"+ userLogged + "/" + id_persona, fingerprints )
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const countCrimeByRelationship = async({commit}, value) =>{
    try {
        const {departamento, id_recinto_penitenciario}=value;
        const {data} = await sirepAPI.get("/filiacion/crimeByRelationship/"+departamento+"/"+id_recinto_penitenciario)
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
